import { useMemo } from 'react';
import MultiSelectFilter from '../../Filter/MultiSelectFilter';
import { useTranslation } from 'react-i18next';
import { ProblemReasonType, normalizeTrackEventType } from "@utils/trackEvents";

const values: Record<string, string[]> = {
  ParcelAccepted: ["0", "1", "2", "11", "50", "55", "56"],
  FirstMileAccepted: ["101", "103", "151"],
  CanceledByOzon: ["5000-27"],
  ExportCustom: ["150", "151", "201", "203", "250", "251"],
  ImportCustom: ["301", "303", "304", "305", "306", "307", "308", "309", "340", "350", "5000-18", "5000-19", "5000-20", "5000-21", "5000-22"],
  LastMileAccepted: ["400", "401", "403", "405", "450", "451"],
  Delivered: ["404", "10000", "10001"],
  Canceled: ["5000"],
  CanceledByCustomer: ["5000-2", "5000-6"],
  // обратный поток — только ReturnFlow-коды: бэк (Sellers.Parcels) сам расширяет их
  // legacy-аналогами при фильтрации, см. TrackEventTypeExtensions.ExpandWithLegacyTypes
  ReturnAccepted: ["6000", "6001", "30000", "30101", "30103"],
  ReturnSent: ["30150"],
  ExportCustomReturn: ["30201", "30250"],
	ImportCustomReturn: ["30301", "30350"],
  LastMileAcceptedReturn: ["30501", "30502", "30505", "30550"],
  DeliveredReturn: ["31000"],
  NotDeliveredReturn: ["31500"],
  NotDeliveredReturnRU: ["31450"],
}

export const getFilterNameByCode = (idRaw?: (number | string), reason?: string) => {
  const numericId = Number(idRaw);
  const id = idRaw ? String(Number.isNaN(numericId) ? idRaw : normalizeTrackEventType(numericId)) : "0";
  const fullId = (reason && id === "5000") ? `${id}-${ProblemReasonType[reason]}` : id
  return Object.keys(values).find(k => values[k].find(v => v === fullId));
}

export const isErrorState = (id?: string) => {
  if (["NotDeliveredReturn", "NotDeliveredReturnRU"].find(v => v === id)) return true;
  return false;
}

const ParcelStatusFilter = ({ asPanel, initialValue, onChange }: {
  asPanel?: boolean,
  initialValue: string[],
  onChange: (v: string[], rv: string[]) => void,
}) => {
  const { t } = useTranslation();

  const data = [
    { id: "ParcelAccepted", value: t('filters.parcelStatusFilter.ParcelAccepted') },
    { id: "FirstMileAccepted", value: t('filters.parcelStatusFilter.FirstMileAccepted') },
    { id: "ExportCustom", value: t('filters.parcelStatusFilter.ExportCustom') },
    { id: "ImportCustom", value: t('filters.parcelStatusFilter.ImportCustom') },
    { id: "LastMileAccepted", value: t('filters.parcelStatusFilter.LastMileAccepted') },
    { id: "Delivered", value: t('filters.parcelStatusFilter.Delivered') },
    { id: "CanceledByCustomer", value: t('filters.parcelStatusFilter.CanceledByCustomer') },
    { id: "CanceledByOzon", value: t('filters.parcelStatusFilter.CanceledByOzon') },
    { id: "ReturnAccepted", value: t('filters.parcelStatusFilter.ReturnAccepted') },
    { id: "ReturnSent", value: t('filters.parcelStatusFilter.ReturnSent') },
    { id: "ExportCustomReturn", value: t('filters.parcelStatusFilter.ExportCustomReturn') },
  	{ id: "ImportCustomReturn", value: t('filters.parcelStatusFilter.ImportCustomReturn') },
    { id: "LastMileAcceptedReturn", value: t('filters.parcelStatusFilter.LastMileAcceptedReturn') },
    { id: "DeliveredReturn", value: t('filters.parcelStatusFilter.DeliveredReturn') },
    { id: "NotDeliveredReturn", value: t('filters.parcelStatusFilter.NotDeliveredReturn') },
  ];

  const getRequestValues = (ids: string[]) => {
    return ids.map(v => (values[v] ?? [])).flat();
  }

  const getValuesFromSaved = (ids: string[]) => {
    // сохранённые ранее фильтры могут содержать legacy-коды — приводим их к ReturnFlow
    const normalizedIds = (ids || []).map(id => {
      const numericId = Number(id);
      return Number.isNaN(numericId) ? id : String(normalizeTrackEventType(numericId));
    });
    return Object.keys(values)
      .filter(v => (
        values[v] && values[v].find(x => normalizedIds.find(id => id === x))
      ))
  }

  const initialValuesRestored = useMemo(
    () => getValuesFromSaved(initialValue),
    [initialValue],
  )

  return (
    <MultiSelectFilter
      asPanel={asPanel}
      data={data}
      initialValue={initialValuesRestored}
      onChange={(v: string[]) => onChange(v, getRequestValues(v))}
      placeholder={t('filters.parcelStatusFilter.title')}
    />
  );
};

export default ParcelStatusFilter;
